import { apiRequest } from "./client";

export interface MyCertificateOut {
  completion_id: number;
  course_id: number;
  course_title: string;
  completed_at: string;
  reg_number: string;
  pdf_url: string;
}

export function listMyCertificates(): Promise<MyCertificateOut[]> {
  return apiRequest<MyCertificateOut[]>("/me/certificates");
}
